/**
 * Breadcrumb handling via document.referrer.
 *
 * For Auto Market Brief articles accessed from the Auto Market Brief landing page:
 * - Removes "Insights" from the breadcrumb trail.
 * - Points the series breadcrumb back to the Auto Market Brief landing page.
 *
 * In all other cases (Insights Hub, direct visit, search, or other pages):
 * - Retains "Insights" (linking to /insights/).
 * - Retains the series breadcrumb linking to the filtered series page (/explore-insights/?insight_series=...).
 */
export default function initBreadcrumbs() {
	// Only execute on single insight posts
	if ( ! document.body.classList.contains( 'single-insight' ) ) {
		return;
	}

	const breadcrumbs = document.querySelector( '.yoast-breadcrumbs' );
	if ( ! breadcrumbs ) {
		return;
	}

	// Detect if this article belongs to Auto Market Brief series / podcast
	const lastLink =
		breadcrumbs.querySelector( '.breadcrumb_last a' ) ||
		breadcrumbs.querySelector( 'a:last-of-type' );

	const isAmbArticle =
		lastLink && lastLink.textContent.toLowerCase().includes( 'auto market brief' );

	if ( ! isAmbArticle ) {
		return;
	}

	const AMB_LANDING_PATH = '/the-auto-market-brief';
	const AMB_DEFAULT_LANDING = '/the-auto-market-brief/';

	let isFromAmbLanding = false;
	let ambLandingUrl = null;

	if ( document.referrer ) {
		try {
			const refUrl = new URL( document.referrer );

			// Ensure referrer is internal (same origin)
			if ( refUrl.origin === window.location.origin ) {
				const refPath = refUrl.pathname.replace( /\/+$/, '' ).toLowerCase();

				// Check if referred specifically from The Auto Market Brief Landing Page
				if ( refPath === AMB_LANDING_PATH || refPath.endsWith( AMB_LANDING_PATH ) ) {
					isFromAmbLanding = true;
					ambLandingUrl = document.referrer;
				}
			}
		} catch ( e ) {}
	}

	if ( isFromAmbLanding ) {
		// Update series breadcrumb link to return to the Auto Market Brief landing page.
		if ( lastLink ) {
			lastLink.setAttribute( 'href', ambLandingUrl || AMB_DEFAULT_LANDING );
		}

		// Remove "Insights" breadcrumb and its adjacent separator.
		const allLinks = breadcrumbs.querySelectorAll( 'a' );
		allLinks.forEach( ( link ) => {
			if ( link.textContent.trim().toLowerCase() === 'insights' ) {
				const parentSpan = link.closest( 'span' );
				if (
					parentSpan &&
					parentSpan !== breadcrumbs &&
					parentSpan.parentElement &&
					! parentSpan.parentElement.classList.contains( 'yoast-breadcrumbs' )
				) {
					let next = parentSpan.nextSibling;
					while (
						next &&
						( next.nodeType === 3 ||
							( next.nodeType === 1 &&
								( next.classList.contains( 'breadcrumb_separator' ) ||
									! next.textContent.trim() ||
									next.textContent.trim() === '»' ||
									next.textContent.trim() === '/' ) ) )
					) {
						const toRemove = next;
						next = next.nextSibling;
						toRemove.remove();
					}
					parentSpan.remove();
				} else {
					let next = link.nextSibling;
					while (
						next &&
						( next.nodeType === 3 ||
							( next.nodeType === 1 &&
								( next.classList.contains( 'breadcrumb_separator' ) ||
									! next.textContent.trim() ||
									next.textContent.trim() === '»' ||
									next.textContent.trim() === '/' ) ) )
					) {
						const toRemove = next;
						next = next.nextSibling;
						toRemove.remove();
					}
					link.remove();
				}
			}
		} );
	}
}
